import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { Pause } from '../pause';

export class PauseBuilder {
    static fromJson(json) {
      return (json)
        ? new Pause(
          json.hash,
          parseNumber(json.startTime),
          parseNumber(json.endTime),
          json.cause
        )
        : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(PauseBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/pause.builder.ts